import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeactivateGuard } from '../../shared/guards/candeactivate';
import { PartsGeneralSettingsComponent } from './parts-general-settings.component';

const routes: Routes = [
  {
    path: '',
    component: PartsGeneralSettingsComponent,
    data: { pageTitle: 'navigation.generalSettings' },
    canDeactivate: [DeactivateGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartsGeneralSettingsRoutingModule { }
